import React, { useEffect, useState } from 'react'
import clientService from '../../services/clientService';
import { message } from 'antd';
import ReusableModalGlobally from './ReusableModalGlobally';

const AddClientModalGlobally = ({ visible, onClose }) => {

    const [loading, setLoading] = useState(false);
    const [websites, setWebsites] = useState([]);

    const fetchWebsites = async () => {
        setLoading(true);
        const result = await clientService.getWebsitesList();
        // Check for API call success and ensure result.data.data is an array, otherwise set to []
        if (result && result.success && Array.isArray(result.data?.data)) {
          setWebsites(result.data.data);
        } else {
          setWebsites([]); // Save [] if response is null or not an array
          message.error("Failed to load websites");
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchWebsites();
    }, []);

    const clientFields = [
        {
            name: "full_name",
            label: "Full Name",
            type: "input",
            rules: [{ required: true, message: "Please enter the full name" }],
        },
        {
            name: "email",
            label: "Email",
            type: "input",
            rules: [
                { required: true, message: "Please enter the email" },
                { type: "email", message: "Please enter a valid email" },
            ],
        },
        {
            name: "username",
            label: "Username",
            type: "input",
        },
        {
            name: "contact_no",
            label: "Contact Number",
            type: "phone",
            rules: [{ required: true, message: "Please enter the contact number" }],
        },

        {
            name: "website",
            label: "Website",
            type: "radio",
            options: websites.map((website) => ({
                id: website.id,
                value: website.id, // You can use website.id as the value
                label: website.name, // Use website.name for the display label
            })),
            rules: [{ required: true, message: "Please select a website" }],
        },
    ];


    return (
        <ReusableModalGlobally
            visible={visible}
            onClose={onClose}
            title="Create Client"
            fields={clientFields}
            fetchLoading={loading}
        />
    )
}

export default AddClientModalGlobally